import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "./assets/css/main.css"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import 'boxicons'

createApp(App).use(store).use(router).mount('#app')
